/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

/** 
 * We are disabling these rules, 
 * because we DO want to add a click event on the main div of the Card
**/

import React, { Component } from 'react';
import PT from 'prop-types';
import cIf from 'classnames';
import { Button } from './button';
import { forEach, toUpper, constant } from 'lodash';

export class Card extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hover: false
        };
    }

    handleOnMouseOver() {
        this.setState({ hover: true });
    }
    
    handleOnMouseOut() {
        this.setState({ hover: false });
    }

    onCardClicked() {
        if (!this.props.isDraggingSlider)
            window.location.href = this.props.cardActionUrl;
    }

    render() {
        let cardContentInfo = null;
        if(this.props.hasInfoDetails)
            cardContentInfo = <CardContentInfo
                                  isWide={this.props.isWide}
                                  title={this.props.title}
                                  subtitle={this.props.subtitle}
                                  details={this.props.details}
                                  buttonTitle={this.props.buttonTitle} 
                                  onCardClicked={this.onCardClicked.bind(this)} 
                                  isCardHover={this.state.hover} 
            />;
        
        return (
            // eslint-disable-next-line sonarjs/mouse-events-a11y
            <div className="rese-card"
                 onClick={this.onCardClicked.bind(this)} 
                 onMouseOver={this.handleOnMouseOver.bind(this)} 
                 onMouseOut={this.handleOnMouseOut.bind(this)}
                 onBlur={constant(null)}
                 onFocus={constant(null)}
                 style={{backgroundImage: `url(${this.props.productImageUrl})`}}
            >
                
                {
                    this.props.flag ? 
                    <CardFlag flag={this.props.flag} /> 
                    : null
                }
                {cardContentInfo}
            </div>
        );
    }
}
Card.defaultProps = {
    hasInfoDetails: true
};

Card.propTypes = {
    isWide: PT.bool,
    hasInfoDetails: PT.bool,
    title: PT.string, 
    subtitle: PT.string,
    details: PT.string,
    cardActionUrl: PT.string,
    isProductImage: PT.bool,
    productImageUrl: PT.string,
    buttonTitle: PT.string,
    isDraggingSlider: PT.bool,
    flag: PT.object
};

class CardContentInfo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hover: false,
            isSmallestTitle: false
        };
        
        this.titleRef = React.createRef();
    }

    componentDidMount() {
        this.setSmallestTitle();
    }

    handleOnMouseOver() {
        this.setState({ hover: true });
    }
    
    handleOnMouseOut() {
        this.setState({ hover: false });
    }
    
    handleCardClick() {
        if(this.props.onCardClicked) this.props.onCardClicked();
    }

    setSmallestTitle() {
        if(this.titleRef.current) {
            const text = this.titleRef.current.textContent;
            
            let countUpperCase = 0;
            forEach(text, (letter) => {
                if (letter === toUpper(letter))
                    countUpperCase++;
            });
            
            if(((!this.props.isWide && text.length >= 23) || countUpperCase > 18)
               || ((this.props.isWide && text.length >= 35) || countUpperCase > 24)) 
                this.setState({ smallestTitle: true });
        }
    }
    
    render() {
        const hover = this.state.hover || this.props.isCardHover;
        const tooltip = (this.state.smallestTitle ? this.props.title : "");

        return (
            <div 
                className={cIf(["rese-event-card-content", {
                    "mouseover": hover,
                    "mouseout": !hover
                }])} 
                onMouseOver={this.handleOnMouseOver.bind(this)} onMouseOut={this.handleOnMouseOut.bind(this)} 
                onBlur={constant(null)}
                onFocus={constant(null)}
            >
                <div className="event-info">
                    <h3 ref={this.titleRef} className={cIf(["ellipsify", { "smallest-title": this.state.smallestTitle }])} title={tooltip}>{this.props.title}</h3>
                    <div className="ellipsify">{this.props.subtitle}</div>
                    <div className="ellipsify" title={this.props.details}>{this.props.details}</div>
                </div>
                <div className="event-button">
                    <Button id="btn-buy-ticket" onButtonClicked={this.handleCardClick.bind(this)}>
                        <i className="rese-button-icon material-icons mdc-button__icon" aria-hidden="true">local_activity</i>
                        <span>{this.props.buttonTitle}</span>
                    </Button>
                </div>
            </div>
        );
    }
}
CardContentInfo.propTypes = {
    isWide: PT.bool,
    title: PT.string, 
    subtitle: PT.string,
    details: PT.string,
    buttonTitle: PT.string,
    onCardClicked: PT.func,
    isCardHover: PT.bool,
};

export class CardFlag extends Component {
    render() {
        return (
            <div className={cIf(["rese-card-flag", this.props.flag.type])}>
                <span>{this.props.flag.label}</span>
            </div>
        );
    }
}
CardFlag.propTypes = {
    flag: PT.shape({
        label: PT.string,
        type: PT.string
    })
};
